export default {
      id: "facebook-usage",
      viewBox: "0 0 40 40",
      url: "/" + "sprite.svg#facebook",
      toString: function () {
        return this.url;
      }
    }